<div class="bulk-csv-upload-dialog">
  <div class="dialog-header">
    <h2>Bulk Tile Configuration</h2>
    <button
      type="button"
      class="close-button"
      (click)="onCloseDialog()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="dialog-content">
    <div class="template-section">
      <h3><i class="fa-solid fa-circle-1"></i> Download CSV Templates</h3>
      <div class="template-section-text">
        <p>Download a template based on the tile type you want to configure. See the <a (click)="tileGlossaryNewTab()">tile term glossary</a> for what values to include in the CSV cells.</p>
      </div>

      <div class="template-buttons">
        <button
          type="button"
          class="white indigo small"
          (click)="downloadNumericTemplate()"
        >
          <i class="fa-regular fa-arrow-down-to-bracket"></i>
          <span>Numeric Configuration Template</span>
        </button>

        <button
          type="button"
          class="white indigo small"
          (click)="downloadToggleTemplate()"
        >
          <i class="fa-regular fa-arrow-down-to-bracket"></i>
          <span>Toggle Configuration Template</span>
        </button>
      </div>
    </div>

    <div class="upload-section">
      <h3><i class="fa-solid fa-circle-2"></i> Upload CSV File</h3>
      <p>Upload your completed CSV file to update tiles in bulk. The CSV must include a "Tile ID" column.</p>

      <div class="file-upload-area">
        <input
          type="file"
          #fileInput
          accept=".csv"
          (change)="onFileSelected($event)"
          style="display: none"
        >

        <div
          class="upload-dropzone"
          (click)="fileInput.click()"
          [ngClass]="{'has-file': selectedFile}"
        >
          @if (!selectedFile) {
            <motn-fa-icon icon="fa-regular fa-cloud-arrow-up"></motn-fa-icon>
            <p>Select your CSV file</p>
          } @else {
            <motn-fa-icon icon="fa-regular fa-file-lines"></motn-fa-icon>
            <p>{{ selectedFile.name }}</p>
            <span class="file-size">{{ formatFileSize(selectedFile.size) }}</span>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <div class="buttons">
      <button
        type="button"
        class="alt"
        (click)="onCloseDialog()"
        [disabled]="processingUpload"
      >
        Cancel
      </button>

      <button
        type="button"
        class="green"
        [disabled]="!selectedFile || processingUpload"
        [class.loading]="processingUpload"
        (click)="processFile()"
      >
        <span>Update Tiles</span>
        <motn-spinner></motn-spinner>
      </button>
    </div>
  </div>
</div>
